import PropTypes from "prop-types";
import React from "react";
import { Box } from "orcs-design-system";

import GroupsNavigationLoader from "src/components/GroupsNavigation";
import {
  useWorkspaceTagConfig,
  useWorkspaceFeatureFlags,
} from "src/contexts/global/WorkspaceContext";

import TagTypeNavigation from "src/components/TagTypeNavigation";
import GoalsExploreContainer from "src/components/GoalsExplore/GoalsExploreContainer";

const ExploreMenu = ({ groupsNavProps }) => {
  const tagTypesConfig = useWorkspaceTagConfig();
  const featureFlags = useWorkspaceFeatureFlags();

  // Get all tag types that should be shown in explore
  const tagTypes = Object.values(tagTypesConfig || {}).filter(
    (config) => config?.showInExplore
  );

  return (
    <Box>
      <GroupsNavigationLoader {...groupsNavProps} />

      {tagTypes.map((tagType) => (
        <Box key={tagType.id} mt="r">
          <TagTypeNavigation tagType={tagType} isSelected={false} />
        </Box>
      ))}

      {featureFlags?.enableGoalsExplorer && (
        <Box mt="r">
          <GoalsExploreContainer />
        </Box>
      )}
    </Box>
  );
};

ExploreMenu.propTypes = {
  groupsNavProps: PropTypes.object,
};

export default ExploreMenu;
